import { doGet } from '../http/httpHelper';

export const getOxygenConsumptionKpi = async ({ startDate, endDate }) => {
    let url = '/oxygen-consumption?';
    const params = [];

    if (startDate && startDate !== '') {
        params.push('startDate=' + startDate);
    }

    if (endDate && endDate !== '') {
        params.push('endDate=' + endDate);
    }

    url += params.join('&');

    const resp = await doGet(url);

    return {
        oxygenConsumed: Number(resp?.oxygenConsumed || resp?.body?.oxygenConsumed || 0),
        unit: resp?.unit || resp?.body?.unit || 'm3',
    };
};

export const getCurrentRentalValueKpi = async ({ startDate, endDate }) => {
    let url = '/current-rental-value?';
    const params = [];

    if (startDate && startDate !== '') {
        params.push('startDate=' + startDate);
    }

    if (endDate && endDate !== '') {
        params.push('endDate=' + endDate);
    }

    url += params.join('&');

    const resp = await doGet(url);

    return {
        currentRentalValue: Number(resp?.currentRentalValue || resp?.body?.currentRentalValue || 0),
        currency: resp?.currency || resp?.body?.currency || 'BRL',
    };
};
